export const DASHBOARD_ROUTES = [
    {
        title: 'Настройки профиля',
        pathname: '/my-profile',
    },
    {
        title: 'Экзамены',
        pathname: ['/exam-timetables', '/exam-applications', '/exam-recognition', '/exam/*', '/applicant-exams'],
    },
    {
        title: 'Квалификации',
        pathname: ['/applicant-qualifications', '/applicant-qualification-details/*'],
    },
    {
        title: 'Подтверждение почты',
        pathname: ['/confirm-email/*'],
    },
    {
        title: 'Успешная оплата',
        pathname: ['/payment/success'],
    },
    {
        title: 'Ошибка при оплате',
        pathname: ['/payment/fail'],
    },
];
